/* @flow */

import * as React from 'react';

import {Button} from 'shells/button';
import {EmptyTimeline} from 'shells/empty-states/empty-timeline';
import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';

import './timeline-empty-state.module.css';

type Props = {
    onRemoveAllFilters?: () => void,
};

export function TimelineEmptyState(props: Props) {
    return (
        <div styleName='empty-state'>
            <div styleName='empty-state-msg'>
                <NothingFoundEmptyState
                    title='No matching entries'
                    subtitle={
                        <Button
                            variant='text-primary'
                            styleName='no-padding'
                            onClick={props.onRemoveAllFilters}
                        >
                            Remove filters
                        </Button>
                    }
                />
            </div>

            <EmptyTimeline />
        </div>
    );
}
